/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const VLINDER_LOGO = require("./res/images/vLogo.png");
export const KLEFKI_LOGO = require("./res/images/klefki.png");

export const DUMMY_IMAGE = require("./res/images/300-300.png");
export const ORDINARY_DAY_IMAGE = require("./res/images/ordinary-day.png");
export const VLINDER_IMAGE = require("./res/images/vlinder-logo.png");
export const APP_LOGO = require("./res/images/icon.png");

export const IMAGES = [
    VLINDER_LOGO,
    KLEFKI_LOGO,
    DUMMY_IMAGE,
    ORDINARY_DAY_IMAGE,
    VLINDER_IMAGE,
    APP_LOGO,
];
